module.exports = __webpack_public_path__ + "static/media/img-card-market-text.35e05892.png";